import { Flex, Text } from "@chakra-ui/react-v3";
import { SmartObservation } from "@metriport/fhir-sdk";
import { getValueAndInterpretation } from "../../shared-components/fhir-sections/labs/shared";
import { ResourceCardLayout } from "../components/resource-card-layout";
import { getDocIdExtension } from "../utils/document-utils";
import { getDateForResourceType } from "../utils/resource-value-extractors";

export type VitalTimelineItemProps = {
  resource: SmartObservation;
  isBloodPressure?: boolean;
  systolicValue?: number;
  diastolicValue?: number;
};

/**
 * Vital-specific timeline item that displays vital signs with value and unit.
 * Handles blood pressure pairs specially with systolic/diastolic display.
 */
export function VitalTimelineItem({
  resource,
  isBloodPressure,
  systolicValue,
  diastolicValue,
}: VitalTimelineItemProps) {
  const date = getDateForResourceType(resource);
  const docId = getDocIdExtension(resource);

  // Use shared utility for value and unit
  const { value, unit } = getValueAndInterpretation(resource);

  if (!date) return null;

  return (
    <ResourceCardLayout date={date} docId={docId} resourceType="Observation" resources={[resource]}>
      <Flex gap={2} wrap="wrap" align="center">
        {/* Blood pressure special formatting */}
        {isBloodPressure && systolicValue !== undefined && diastolicValue !== undefined ? (
          <Text fontSize="md" fontWeight="medium" color="fg.emphasized">
            {systolicValue}/{diastolicValue} {unit || "mmHg"}
          </Text>
        ) : (
          <Text fontSize="md" fontWeight="medium" color="fg.emphasized">
            {value?.toString() || "-"}
            {unit && ` ${unit}`}
          </Text>
        )}
      </Flex>
    </ResourceCardLayout>
  );
}
